export type SpaceGroupMemberRole = "Admin" | "Moderator" | "Member";

interface Roles {
  admin?: boolean;
  moderator?: boolean;
}

export interface RawSpaceGroupMember {
  avatar_url?: string | null;
  email: string;
  id: number | string;
  moderating_space_group_ids?: number[];
  name: string;
  public_uid: string;
  roles?: Roles;
}

export const getSpaceGroupMemberRole = (
  member: RawSpaceGroupMember,
  spaceGroupId: number,
): SpaceGroupMemberRole => {
  const moderatingIds = member.moderating_space_group_ids ?? [];
  if (member.roles?.admin) return "Admin";
  if (member.roles?.moderator && moderatingIds.includes(spaceGroupId)) {
    return "Moderator";
  }
  return "Member";
};
